import { View, Platform } from 'react-native';
import LottieView from '@utils/lottieAnimation';
import React from 'react';
import AnimatedTextFunction from '@hooks/animateTextEntry';
import * as Animatable from 'react-native-animatable';
import styles from '@stylesheet';
import { Text } from '@constants/Themed';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
interface LoadingProps {
  text?: string
}

export const Loading = ({ text }: LoadingProps) => {
  const theme = themeSelector();
  return (
    <Animatable.View
            animation="fadeIn"
            duration={300}
            style={[
              styles.modernCard,
              {
                minHeight: 100,
                justifyContent: 'center',
                alignItems: 'center',
                gap: 16,
                backgroundColor: theme ? 'rgba(255,255,255,0.95)' : 'rgba(30,30,30,0.95)',
                borderColor: theme ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.08)',
                borderWidth: 1,
                borderRadius: 24,
                maxHeight: 400,
                width: 300,
                flex: 1,
                ...(Platform.OS === 'web' && {
                  boxShadow: theme
                    ? '0 8px 32px rgba(0,0,0,0.08)'
                    : '0 8px 32px rgba(0,0,0,0.3)',
                }),
                ...styles as any
              }
            ]}
          >
            <View style={{
              width: 80,
              height: 80,
              backgroundColor: theme ? 'rgba(90,192,234,0.1)' : 'rgba(90,192,234,0.2)',
              borderRadius: 40,
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <LottieView
                style={{ height: 50, width: 50 }}
                source={require("@assets/animations/spin-leaf-loader.json")}
                autoPlay
                loop
              />
              {
                text &&
                <Text>{text}</Text>
              }
            </View>
          </Animatable.View>
  )
}